import React from "react";
import { connect } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import Axios from "axios-https-proxy-fix";
import Translated from "../../../components/Translated/Translated";

function DialogDelete(props) {
	const [open, setOpen] = React.useState(false);
	const [response, setResponse] = React.useState({});
	const [loading, setLoading] = React.useState(false);

	async function handleClose() {
		setOpen(false);
	}

	async function handleClickOpen() {
		setResponse({});
		setOpen(true);
	}

	async function submit() {
		setLoading(true);
		let requestURL = props.APIUrl + "/emco_quotes/delete-products";
		let data = {
			trendId: localStorage.getItem("trendId"),
			token: localStorage.getItem("token"),
			project_id: props.projectId,
			products: Object.keys(props.products),
			wishlistIds: Object.values(props.products)
		};
		let APIResponse = await Axios.post(requestURL, data);
		setResponse(APIResponse.data);
		if (APIResponse.data.hasOwnProperty("success")) {
			props.deleteRows();
		}
		setLoading(false);
	}

	function formBody() {
		return (
			<div class="quote-dialog-body">
				<div class="fquote-dialog-info">
					<div><Translated section="Misc" label="product_delete_selected_dialog_message" /></div>
				</div>
			</div>
		);
	}

	function responseBody() {
		let class_names = "quote-dialog-body quote-dialog-";
		class_names += response.hasOwnProperty("error") ? "error" : "success";

		return (
			<div className={class_names}>
				<div>{response.hasOwnProperty("error") ? response.error : response.success}</div>
			</div>
		);
	}

	let hasResponse = Object.keys(response).length;

	return (
		<div class="">
			<button onClick={handleClickOpen}><Translated section="Quote" label="delete_selected_label" /></button>
			<Dialog open={open} onClose={handleClose}>
				<div class="quote-dialog">
					<div class="quote-dialog-title"><Translated section="Misc" label="delete_product_selected_dialog_title" /></div>

					{hasResponse ? responseBody() : formBody()}

					<div class="quote-dialog-footer">
						<button class="quote-dialog-button" onClick={handleClose}>
							{hasResponse 
								? <Translated section="Misc" label="close_btn" />
								: <Translated section="Misc" label="no_btn" />
							}
						</button>
						{hasResponse ? (
							""
						) : (
							<button class="quote-dialog-button" onClick={submit} disabled={loading ? true : false}>
								{loading 
									? <i class="fa fa-spinner fa-spin"></i>
									: <Translated section="Misc" label="yes_btn" />
								}
							</button>
						)}
					</div>
				</div>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	projectId: state.projectIdUsedToIncreaseProductQuantity
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DialogDelete);
